import React from "react";
import {Button} from "react-bootstrap";


export default class Paginator extends React.Component {
    constructor(props) {
        super(props);
    }



    render() {
        let self = this;
        let selectedIndex = parseInt(this.props.selectedIndex) || 0;
        let range = parseInt(this.props.range) || 5;
        let total = parseInt(this.props.total) || 1;

        let first = Math.max(0, selectedIndex - range);
        let last = Math.min(selectedIndex + range, total - 1);        
        let shouldDisableBackButtons = selectedIndex === 0;
        let shouldDisableNextButtons = selectedIndex === (total - 1);        
        if (total > 0) {
            var pageButtons = [];
            for(var i=first; i<=last; i++) {
                let className = i == selectedIndex ? "btn-primary" : "";
                let index = i;
                pageButtons.push(<Button key={`page_${i+1}`} className={className} disabled={className != ""}
            onClick={() => self.props.onNavigate(index)}>{i+1}</Button>);
            }

            return (
                <div className="ap-paginator">
                    <Button disabled={shouldDisableBackButtons}
                    onClick={() => this.props.onNavigate(0)}>
                        <span className="glyphicon glyphicon-step-backward" />
                    </Button>
                    <Button disabled={shouldDisableBackButtons}
                    onClick={() => this.props.onNavigate(selectedIndex-1)}>
                        <span className="glyphicon glyphicon-triangle-left" />
                    </Button>
                    {pageButtons}
                    <Button disabled={shouldDisableNextButtons}
                    onClick={() => this.props.onNavigate(selectedIndex+1)}>
                        <span className="glyphicon glyphicon-triangle-right"/>
                    </Button>
                    <Button disabled={shouldDisableNextButtons}
                    onClick={() => this.props.onNavigate(total-1)}>
                        <span className="glyphicon glyphicon-step-forward"/>
                    </Button>                    
                </div>
            );
        } else {
            return (<div></div>);
        }
    }
}

